import { registerSymbol } from "../../serializers/symbolSerializer";
import { FillStyle, PolyRender } from "../../renders/Poly";
import { getRenderedPolygonCoordinates } from '../../utils/math';
import { Symbol } from "../Symbol";
import { Poly } from "../../features/Poly";
/**
 * Symbol of polygon with image filling.
 * @alias sGis.symbol.polygon.ImageFill
 */
export class ImageFill extends Symbol {
    /**
     * @param options - key-value list of the properties to be assigned to the instance.
     */
    constructor({ src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=', strokeWidth = 1, strokeColor = 'block', lineDash = [], shadow = null } = {}) {
        super();
        this._image = new Image();
        /** @see [[PolyRender.lineDash]] */
        this.lineDash = [];
        /** @see [[PolyRender.lineCap]] */
        this.lineCap = "round";
        /** @see [[PolyRender.lineJoin]] */
        this.lineJoin = "round";
        /** @see [[PolyRender.miterLimit]] */
        this.miterLimit = 10;
        /** Emulation CanvasRenderingContext2D.filter drop-shadow. */
        this.shadow = null;
        /** Drawn stroke outside. */
        this.isOutsideStroke = false;
        /** Drawn stroke inside. */
        this.isInsideStroke = false;
        this.strokeWidth = strokeWidth;
        this.strokeColor = strokeColor;
        this.lineDash = lineDash;
        this._src = src;
        this.shadow = shadow;
        this._updateImage();
    }
    renderFunction(feature, resolution, crs) {
        if (!(feature instanceof Poly))
            return [];
        if (!this._image.complete) {
            this._image.onload = feature.redraw.bind(feature);
            return [];
        }
        let coordinates = getRenderedPolygonCoordinates(feature, resolution, crs);
        return [new PolyRender(coordinates, {
                enclosed: true,
                strokeColor: this.strokeColor,
                strokeWidth: this.strokeWidth,
                fillStyle: FillStyle.Image,
                fillImage: this._image,
                lineDash: this.lineDash,
                shadow: this.shadow,
                lineCap: this.lineCap,
                lineJoin: this.lineJoin,
                miterLimit: this.miterLimit,
                isOutsideStroke: this.isOutsideStroke,
                isInsideStroke: this.isInsideStroke,
            })];
    }
    /**
     * Source for the filling image. Can be url or data:url string.
     */
    get src() { return this._src; }
    set src(src) {
        this._src = src;
        this._updateImage();
    }
    _updateImage() {
        this._image = new Image();
        this._image.src = this._src;
    }
}
registerSymbol(ImageFill, 'polygon.ImageFill', ['src', 'strokeColor', 'strokeWidth', 'lineDash', 'shadow', 'lineCap', 'lineJoin', 'miterLimit', 'isOutsideStroke', 'isInsideStroke']);
